export const redirectToStepTwo = (redirectToStepTwo) => ({ type: "SET_REDIRECT", redirectToStepTwo: redirectToStepTwo })



// WEBPACK FOOTER //
// src/actions/stepOneActions.js